// @flow
import * as React from 'react';
import { Link } from 'react-router';

type Params = {
  context: string,
  organisationId: number,
  userId: number
};

type Props = {
  activeTab: string,
  params: Params
};

class UserTabSidebar extends React.Component<Props> {
  render() {
    const {
      activeTab,
      params: { context, organisationId, userId }
    } = this.props;

    if (activeTab === 'UserInvitation') {
      return (
        <div className="industries-sidebar-section">
          <ul>
            <li className="active">
              <Link to={`/${context}/${organisationId}/users/invite`}>
                Invite
              </Link>
            </li>
          </ul>
        </div>
      );
    }

    return (
      <div className="industries-sidebar-section">
        <ul>
          <li className={activeTab === 'UserDetails' ? 'active' : 'not'}>
            <Link to={`/${context}/${organisationId}/users/${userId}`}>
              Details
            </Link>
          </li>
          {context === 'global' && (
            <li className={activeTab === 'UserCustomers' ? 'active' : 'not'}>
              <Link to={`/${context}/0/users/${userId}/customers`}>
                Customers
              </Link>
            </li>
          )}
          {context !== 'sub-account' && (
            <li className={activeTab === 'UserAccounts' ? 'active' : 'not'}>
              <Link
                to={`/${context}/${organisationId}/users/${userId}/accounts`}
              >
                Sub-Accounts
              </Link>
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default UserTabSidebar;



// WEBPACK FOOTER //
// ./src/containers/users/UserTabSidebar.js